/** Wartość NestedSelect: "Practice:12" | "Methodology:3" — id z różnych tabel nie kolidują. */
export type PinnedToType = 'Practice' | 'Methodology';

export const pinnedToSelectValue = (
  type: PinnedToType,
  id: string | number
): string => `${type}:${id}`;

export const parsePinnedToSelectValue = (
  value?: string | null
): { pinned_to_type: PinnedToType; pinned_to_id: string } | null => {
  if (!value) return null;
  const [type, id] = value.split(':');
  if ((type !== 'Practice' && type !== 'Methodology') || !id) return null;
  return { pinned_to_type: type, pinned_to_id: id };
};
